var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodAndDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71 4.9A1.9 1.9 0 0 0 1 7.97l.87 6.64h6.15l.83-6.26a1.54 1.54 0 0 0 .22-2.12A1.9 1.9 0 0 0 7.5 3.78a2.03 2.03 0 0 0-3.27-.59 1.9 1.9 0 0 0-2.53 1.72ZM8 6.47a.73.73 0 0 1 .42 1.16H1.85a1.09 1.09 0 0 1 .9-1.97 1.09 1.09 0 1 1 1.75-1.3 1.21 1.21 0 0 1 2.38.28 1.09 1.09 0 0 1 1.46 1.04c0 .3-.13.59-.34.79ZM5.96 8.44l-.44 5.34H4.37l-.44-5.34h2.03Zm.82 0H8l-.7 5.34h-.97l.44-5.34Zm-3.67 0 .44 5.34H2.6l-.7-5.34H3.1Zm3.47-2.72a.4.4 0 1 0 .81 0 .4.4 0 0 0-.81 0Zm-1.5 1.22a.4.4 0 1 1 0-.81.4.4 0 0 1 0 .81ZM3.32 5.18a.4.4 0 1 0 .81 0 .4.4 0 0 0-.81 0ZM15.1 5.65a.4.4 0 0 1-.3.47l-1.65.32v1.01h1.55c.66 0 1.2.54 1.2 1.2v.76h-.63l-.6 5.21h-3.85l-.59-5.21H9.6v-.76c0-.66.54-1.2 1.2-1.2h1.55V5.78l2.29-.45a.4.4 0 0 1 .47.32ZM11.05 9.4l.1.94h3.22l.1-.94h-3.42Zm3.23 1.74h-3.04l.11.94h2.82l.1-.94Zm-.2 1.74h-2.64l.1.93h2.43l.11-.93ZM10.4 8.6h4.7a.4.4 0 0 0-.4-.36h-3.9a.4.4 0 0 0-.4.36Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAndDrink);
export default __webpack_public_path__ + "static/media/foodAndDrink.d49626640a6903e1706bbf0fa2ef432f.svg";
export { ForwardRef as ReactComponent };